import { bindable, inject } from 'aurelia';

export interface RegistrationTeamListRow {
    id?: string;
    suffix: string;
    isDuplicate?: boolean;
}

@inject(Element)
export class RegistrationTeamList {
    @bindable public associationName: string = '';
    @bindable public rows: RegistrationTeamListRow[] = [];
    @bindable public canEdit: boolean = false;
    @bindable public showEmptyState: boolean = false;
    @bindable public hasDuplicates: boolean = false;

    constructor(private readonly _element: Element) {}

    public addTeam(): void {
        this._element.dispatchEvent(new CustomEvent('add-team', { bubbles: true }));
    }

    public removeTeam(index: number, team: RegistrationTeamListRow): void {
        this._element.dispatchEvent(new CustomEvent('remove-team', {
            detail: { index, team },
            bubbles: true,
        }));
    }

    public teamInput(team: RegistrationTeamListRow): void {
        this._element.dispatchEvent(new CustomEvent('team-input', {
            detail: { team },
            bubbles: true,
        }));
    }

    public saveTeam(team: RegistrationTeamListRow): void {
        this._element.dispatchEvent(new CustomEvent('team-save', {
            detail: { team },
            bubbles: true,
        }));
    }
}
